import {Component} from 'react'
import './index.css'

class CharacterCount extends Component {
  render() {
    const {characterList = []} = this.props
    const hasItems = characterList.length > 0

    return (
      <div className="left-panel-container">
        <h1 className="left-title">Count the characters like a Boss...</h1>

        {hasItems ? (
          <ul className="chars-list">
            {characterList.map(item => (
              <li key={item.id} className="char-item">
                <p className="char-name">{item.name}</p>
                <p className="char-length">{item.name.length}</p>
              </li>
            ))}
          </ul>
        ) : (
          <img
            src="https://assets.ccbp.in/frontend/react-js/no-user-inputs-img.png"
            className="no-chars-img"
            alt="no user inputs"
          />
        )}
      </div>
    )
  }
}

export default CharacterCount
